import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getDashboardUrl } from "../utils/urlHelper";

const dashboardPageApi = createApi({
  reducerPath: "dashboardPage",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.NEXT_PUBLIC_LOGIN_URL}`,
    prepareHeaders: async (headers) => {
      const token = await sessionStorage.getItem("token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      headers.set("Accept", "application/json; version=3.0");
      headers.set("Source", "LPLWEB");
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getDashboard: builder.query({
      query: (appId) => ({
        url: getDashboardUrl(appId),
        method: "GET",
      }),
    }),
  }),
});

export const { useGetDashboardQuery } = dashboardPageApi;
export { dashboardPageApi };
